import React from "react"

import { ProjectGaebOverlay } from "./ProjectGaebOverlay"
import { useProjectGaebOverlayModel } from "./hooks/useProjectGaebOverlayModel"

export interface ProjectGaebPayload {
  projectID: string
  isShareID?: boolean
}

export interface ProjectGaebOverlayConnectorProps {
  payload: ProjectGaebPayload
}

export const ProjectGaebOverlayConnector = React.memo(
  (props: ProjectGaebOverlayConnectorProps) => (
    <ProjectGaebOverlay {...useProjectGaebOverlayModel(props)} />
  )
)
